import { Loader2Icon } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { usePageTitle } from '@/hooks/use-page-title';
import { PlatformPageHeader } from '@/platform/components/platform-page-header';
import { useProfileEdit } from '@/platform/features/profile/profile-edit-context';
import { ProfileNotificationsPreferences } from '@/platform/features/profile/profile-notifications-preferences';

export function ProfileNotificationsPage() {
  usePageTitle('Mitteilungen · Profil');
  const {
    savingPreferences,
    savePreferencesOnly,
    followsTenantStandard,
    hasPersonalPreferences,
    restorePreferences,
  } = useProfileEdit();

  return (
    <section className="mx-auto max-w-5xl space-y-6">
      <PlatformPageHeader
        title="Mitteilungen"
        description="In-App, E-Mail und Push pro Ereignis."
      />

      <form className="space-y-6" onSubmit={(event) => void savePreferencesOnly(event)}>
        <Card>
          <CardHeader>
            <CardTitle>Mitteilungen</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            {followsTenantStandard ? (
              <p>Diese Werte sind der Mitteilungs-Standard. Speichern behält eine eigene Kopie.</p>
            ) : null}
            <ProfileNotificationsPreferences />
          </CardContent>
        </Card>

        <div className="flex flex-wrap gap-2">
          <Button type="submit" disabled={savingPreferences}>
            {savingPreferences && <Loader2Icon className="animate-spin" aria-hidden />}
            Speichern
          </Button>
          {hasPersonalPreferences ? (
            <Button type="button" variant="outline" onClick={() => void restorePreferences()}>
              Standard wiederherstellen
            </Button>
          ) : null}
        </div>
      </form>
    </section>
  );
}
